// extracted by mini-css-extract-plugin
export default {"Image":"fRnie","loaderWrap":"b6RGM","lessThanFrame":"isX_I","widthGreaterThanFrame":"U4eNM","heightGreaterThanFrame":"uTeq6","bothGreaterThanFrame":"caZGu","cursor":"iuiw3"};